export default __webpack_public_path__ + "static/media/Gambetta-Light.34c53d67.woff2";